module.exports = __webpack_public_path__ + "img/top2.ba848d17.png";